/* eslint-disable no-unused-vars */
import numbersHelper from '@/core/mixins/numbersHelper';
import {
  format,
  parseISO,
  isValid,
  isPast,
  isFuture,
  isToday,
} from 'date-fns';

export default {
  mixins: [
    numbersHelper,
  ],
  methods: {
    isDateInThePast(dateString) {
      return dateString && isPast(Date.parse(dateString));
    },
    isDateCurrentOrInThePast(dateString) {
      return dateString && (isPast(Date.parse(dateString)) || isToday(Date.parse(dateString)));
    },
    isDateCurrentOrInTheFuture(dateString) {
      return dateString && (isFuture(Date.parse(dateString)) || isToday(Date.parse(dateString)));
    },
    isDatePeriodCurrent(startDate, endDate) {
      return this.isDateCurrentOrInThePast(startDate) && this.isDateCurrentOrInTheFuture(endDate);
    },
    formatDate(date, formats) {
      if (!isValid(new Date(date))) return '';
      if (typeof date !== 'string') return format(parseISO(this.convertDateToString(date)), formats);
      return format(parseISO(date), formats);
    },
    formatDateForEoC(date) {
      return this.formatDate(date, 'dd/MM/yyyy');
    },
    formatDateForPlatform(date) {
      return this.formatDate(date, 'dd/MM/yyyy');
    },
    convertDateToString(date) {
      if (!date || !isValid(new Date(date))) return null;
      const adjustedDate = new Date(date);
      return `${adjustedDate.getFullYear()}-${this.convertNumberToString(adjustedDate.getMonth() + 1)}-${this.convertNumberToString(adjustedDate.getDate())}`;
    },
  },
};
